import { Flex } from 'antd';
import React from 'react';

import { Button, ButtonSizes, ButtonVariant } from '../Button';
import { Icon } from '../Icon';
import { Typography } from '../Typography';

import { TextInput } from './TextInput';

import './MultipleFormTextInput.scss';

export interface MultipleFormTextInputProps {
  label: string;
  maxTextInputsQuantity?: number;
  onChange: (texts: string[]) => void;
  defaultValue?: string[];
  value: string[];
  errors: Array<{ message: string }>;
  addButtonText?: string;
}

export const MultipleFormTextInput: React.FC<MultipleFormTextInputProps> = ({
  value,
  errors,
  onChange,
  maxTextInputsQuantity,
  label,
  addButtonText = 'Додати',
}) => {
  return (
    <>
      {value.map((text, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Flex key={index} justify="center" align="end" gap={16}>
          <TextInput
            label={label}
            value={text}
            onChange={(textValue) => {
              const newTextsArray = [...value];
              newTextsArray[index] = textValue.target.value;
              onChange(newTextsArray);
            }}
            errorMessage={errors?.[index]?.message}
          />
          {value.length !== 1 && (
            <Button
              variant={ButtonVariant.SECONDARY}
              onClick={() => {
                const newTextsArray = [...value];
                newTextsArray.splice(index, 1);
                onChange(newTextsArray);
              }}
              className="multiple-form-text-input__delete-button"
            >
              <Icon name="delete" color="red" />
            </Button>
          )}
        </Flex>
      ))}
      {value?.length !== maxTextInputsQuantity && (
        <Button
          variant={ButtonVariant.SECONDARY}
          size={ButtonSizes.SM}
          onClick={() => {
            const newTextsArray = [...value];
            newTextsArray.push('');
            onChange(newTextsArray);
          }}
          className="multiple-form-text-input__add-button"
        >
          <Typography>{addButtonText}</Typography>
        </Button>
      )}
    </>
  );
};
